var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarehouse = function SvgWarehouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Warehouse_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Warehouse_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 34.451c.329 0 .651-.132.884-.365.232-.233.366-.555.366-.885a1.26 1.26 0 0 0-.366-.884 1.26 1.26 0 0 0-.884-.366 1.26 1.26 0 0 0-.884.366 1.26 1.26 0 0 0-.366.884c0 .33.134.652.366.885.233.233.555.365.884.365Z",
    fill: "#037C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.855 17.156-11.424-6.315a1.25 1.25 0 1 0-1.21 2.187L62 18.988V61.5h-5.5V22.25c0-.69-.56-1.25-1.25-1.25H9.75c-.69 0-1.25.56-1.25 1.25v5.952a1.25 1.25 0 1 0 2.5 0V23.5h43v38h-5.234V49c0-1.378-1.121-2.5-2.5-2.5h-5V34c0-1.378-1.121-2.5-2.5-2.5h-12.5a2.503 2.503 0 0 0-2.5 2.5v12.5H18.75a2.503 2.503 0 0 0-2.5 2.5v12.5H11V38.202a1.25 1.25 0 1 0-2.5 0V61.5H3V18.987L32.5 2.678l9.97 5.512a1.25 1.25 0 0 0 1.209-2.188L33.105.156a1.249 1.249 0 0 0-1.21 0l-30.75 17c-.398.22-.645.639-.645 1.094v44.5c0 .69.56 1.25 1.25 1.25h61.5c.69 0 1.25-.56 1.25-1.25v-44.5a1.25 1.25 0 0 0-.645-1.094ZM38.766 49h2.5v2.5h-2.5V49ZM33.75 34v2.5h-2.5V34h2.5Zm-7.484 0h2.484v3.75c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25V34h2.516l.002 12.5H26.266V34Zm0 15v2.5h-2.5V49h2.5ZM18.75 61.5V49h2.516v3.75c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25V49h2.484l.002 12.5H18.75Zm15.016 0V49h2.5v3.75c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25V49h2.5l.002 12.5H33.766Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45 10.765c.329 0 .651-.134.884-.366a1.26 1.26 0 0 0 .366-.884c0-.329-.134-.651-.366-.884a1.26 1.26 0 0 0-.884-.366c-.329 0-.651.134-.884.366a1.26 1.26 0 0 0-.366.884c0 .329.134.651.366.884.233.232.555.366.884.366ZM27.25 12.75A5.256 5.256 0 0 0 32.5 18a5.256 5.256 0 0 0 5.25-5.25A5.256 5.256 0 0 0 32.5 7.5a5.256 5.256 0 0 0-5.25 5.25Zm8 0a2.753 2.753 0 0 1-2.75 2.75 2.753 2.753 0 0 1-2.75-2.75A2.753 2.753 0 0 1 32.5 10a2.753 2.753 0 0 1 2.75 2.75Z",
    fill: "#037C5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Warehouse_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h64v64H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Warehouse_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h64v64H0z"
  })))));
};

export default SvgWarehouse;